import { dictEntity } from 'shared';
import type { Dict } from '@aviata/platform-types';

import { existingPictures, citiesByAirports } from './config';

export const getCityImgSrc = (
  airport: string,
  dict?: Dict.Entity,
  notDefaultAllowed?: boolean,
) => {
  let iata = airport;

  if (dict) {
    iata = dictEntity.lib.getCityByAirport(airport, dict).iata;
  } else if (iata in citiesByAirports) {
    iata = citiesByAirports[iata];
  }

  if (existingPictures[iata]) {
    return new URL(`../../assets/images/cities/${iata}.webp`, import.meta.url)
      .href;
  }
  if (!notDefaultAllowed) {
    return new URL(`../../assets/images/cities/default.webp`, import.meta.url)
      .href;
  }
  return undefined;
};
